import React, { useContext } from "react";
import { Breadcrumb } from "antd";
import { HomeOutlined, RightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useBreadcrumb } from "../hooks/useBreadcrumb";
import BreadcrumbContext from "../contexts/BreadcrumbContext";

const PRIMARY = "#242166";
const LINK_COLOR = "#4a90e2";

const AppBreadcrumb = () => {
  const crumbs = useBreadcrumb();
  const navigate = useNavigate();

  // Label dynamique optionnel fourni par la page courante
  const ctx = useContext(BreadcrumbContext);
  const dynamicTitle = ctx?.pageTitle || null;

  // N'affiche rien sur la page d'accueil ou si un seul niveau
  if (crumbs.length <= 1) return null;

  const items = crumbs.map((crumb, index) => {
    const isFirst = index === 0;
    const isLast = index === crumbs.length - 1;

    if (isFirst) {
      return {
        title: (
          <span
            onClick={() => navigate("/")}
            style={{ cursor: "pointer", color: LINK_COLOR, display: "flex", alignItems: "center", gap: 4 }}
          >
            <HomeOutlined style={{ fontSize: 13 }} />
          </span>
        ),
      };
    }

    // Dernier segment : utilise le label dynamique si disponible
    if (isLast) {
      return {
        title: (
          <span style={{ color: PRIMARY, fontWeight: 500 }}>
            {dynamicTitle || crumb.label}
          </span>
        ),
      };
    }

    // Segment intermédiaire sans path → non cliquable (ex: "Production", "Sinistres")
    if (!crumb.path) {
      return {
        title: (
          <span style={{ color: "rgba(36,33,102,0.55)" }}>
            {crumb.label}
          </span>
        ),
      };
    }

    // Segment intermédiaire avec path → cliquable
    return {
      title: (
        <span
          onClick={() => navigate(crumb.path)}
          style={{ cursor: "pointer", color: LINK_COLOR }}
        >
          {crumb.label}
        </span>
      ),
    };
  });

  return (
    <div style={breadcrumbBarStyle}>
      <Breadcrumb
        items={items}
        separator={<RightOutlined style={{ fontSize: 9, color: "rgba(36,33,102,0.35)" }} />}
      />
    </div>
  );
};

const breadcrumbBarStyle = {
  padding: "6px 32px",
  background: "rgba(36, 33, 102, 0.03)",
  borderBottom: "1px solid rgba(36, 33, 102, 0.07)",
  fontSize: 13,
};

export default AppBreadcrumb;
